// One serial writer per attempt. Failed writes remain pending for an explicit retry.
export function createAnswerQueue(send, onStatus = () => {}) {
  const pending = new Map();
  let running = null;
  let version = 0;
  const flush = () => {
    if (running) return running;
    running = (async () => {
      onStatus(pending.size ? "saving" : "saved");
      while (pending.size) {
        const [id, item] = pending.entries().next().value;
        try {
          await send(id, item.value);
        } catch (error) {
          onStatus("error");
          throw error;
        }
        if (pending.get(id)?.version === item.version) pending.delete(id);
      }
      onStatus("saved");
    })().finally(() => { running = null; });
    return running;
  };
  return {
    enqueue(id, value) {
      pending.set(id, {value, version: ++version});
      return flush();
    },
    flush,
    hasPending: () => pending.size > 0,
  };
}
